import { render, staticRenderFns } from "./EatingOut.vue?vue&type=template&id=5b9b6999"
import script from "./EatingOut.vue?vue&type=script&lang=js"
export * from "./EatingOut.vue?vue&type=script&lang=js"
import style0 from "./EatingOut.vue?vue&type=style&index=0&id=5b9b6999&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports